export const translations = {
  he: {
    landing: {
      heroTitle1: 'המדיה שבה סוף-סוף רואים,',
      heroTitle2: 'זוכרים ושומעים ',
      heroTitle2Bold: 'את הכסף שלך',
      heroTitle2Suffix: '!',
      heroDesc1: 'באמצעות שיתוף פעולה ייחודי עם ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ', המותג שלכם נוכח בלמעלה מ-',
      heroDesc1Highlight: '400,000 בתי אב',
      heroDesc1End: ' בישראל – בזמן צפייה והאזנה לתחנות רדיו וערוצי פודקאסטים דרך הטלוויזיה.',
      heroDesc2: 'אלו רגעים נדירים של תשומת לב:',
      heroDesc2Line2: 'מוזיקה, תוכן, רוגע – והמסך פתוח.',
      videoTitle: 'מהפכת הפרסום הביתי: כשהרדיו פוגש את מסך הטלוויזיה',
      pricingCtaTitle: 'נשמח לשמוע מכם',
      pricingCtaSubtitle: 'תמחור לפי הצגות — מחירון פשוט ושקוף.',
      pricingCtaCpmUnit: 'CPM',
      pricingCtaPerThousand: 'לכל 1,000 הצגות וידאו',
      pricingTitle: 'תמחור לפי CPM',
      pricingSubtitle:
        '₪15 לכל 1,000 הצגות וידאו. צרו איתנו קשר ונחזור אליכם עם פרטים והצעה מסחרית.',
      pricePerMonth: 'לחודש',
      pricingCardPriceLine: '₪15 CPM',
      pricingCardSubline: 'לכל 1,000 הצגות וידאו',
      feature1: 'פרסום ב־GSRadio Android TV ו־Partner TV',
      feature2: 'תמחור קבוע לפי נפח הצגות — ₪15 לכל אלף הצגות',
      ctaStart: 'התחל עכשיו',
      faqTitle: 'שאלות נפוצות',
      faq1Q: 'מה זה GSRadio TV?',
      faq1A:
        'GSRadio TV הוא פלטפורמת הפרסום של GSRadio על טלוויזיה חכמה (Android TV) בשיתוף Partner TV: פרסומות כרקע ויזואלי רגוע בזמן האזנה לרדיו ולפודקאסטים על המסך — בלמעלה מ־400,000 בתי אב בישראל.',
      faq2Q: 'כמה עולה הפרסום?',
      faq2A:
        'התמחור הוא ₪15 לכל 1,000 הצגות וידאו (CPM). לחצו על «התחל עכשיו» ליצירת קשר בווטסאפ והמשך מסחרי.',
      faq3Q: 'איך מתחילים?',
      faq3A: 'לחצו על "התחל עכשיו" וצרו איתנו קשר. נעזור לכם להכין את הווידאו והעיצוב לפי ההנחיות שלנו.',
      faq4Q: 'מה הדרישות לווידאו?',
      faq4A:
        'הווידאו חייב להיות באורך 20 שניות בדיוק, ללא סאונד, בפורמט MP4 (H.264). פרטים נוספים יינתנו בתהליך ההצטרפות.',
      serviceHighlightsTitle: 'מה אנחנו מציעים לעסקים',
      serviceHighlightsSubtitle:
        'פרסום וידאו רגוע בזמן האזנה, באפליקציית GSRadio על Android TV (ובשיתוף Partner TV) — מסר ברור בלי רעש של פיד.',
      servicePoint1Title: 'מסך גדול, קשב ביתי',
      servicePoint1Text:
        'בזמן האזנה לרדיו בבית הטלוויזיה היא מוקד — פרסום רקע ויזואלי רגוע, בלי מרדף אחרי קליקים.',
      servicePoint2Title: 'תמחור לפי נפח הצגות',
      servicePoint2Text:
        '₪15 לכל 1,000 הצגות וידאו (CPM); נפח ותזמון הקמפיין נקבעים יחד איתכם.',
      servicePoint3Title: 'סרטונים 20–30 שניות',
      servicePoint3Text:
        'תכנים לפי מיקום ו/או תחנה, עם אפשרות לאלמנטים אינטראקטיביים והפקת וידאו (בתשלום).',
      statBroadcastHoursVal: '14,000+',
      statBroadcastHours: 'שעות שידור בחודש (בערך)',
      statViewingHoursVal: '600+',
      statViewingHours: 'שעות צפייה ביום (בערך)',
      statHomesVal: '400,000',
      statHomes: 'בתי אב עם ממירים (ישראל)',
      serviceStatsFootnote: '* נתונים להמחשה; מקורות ועדכונים לפי דוח אסטרטגיה ושוק.',
      calcSectionTitle: 'מחשבון מחיר משוער',
      calcSectionSubtitle:
        'הזינו הערכה למספר הצגות הווידאו. החישוב: ₪20 לכל 1,000 הצגות (CPM).',
      calcImpressionsLabel: 'מספר הצגות וידאו (משוער)',
      calcCpmRateHint: '₪20 לכל 1,000 הצגות.',
      calcEstimatedPeriod: 'לפי הנפח שהוזן',
      calcGeoLabel: 'מיקום גיאוגרפי',
      calcGeoAll: 'כל הארץ',
      calcGeoNorth: 'צפון',
      calcGeoSouth: 'דרום',
      calcGeoShfela: 'שפלה',
      calcGeoSharon: 'השרון',
      calcGeoTelAviv: 'ת״א והסביבה',
      calcGeoJerusalem: 'ירושלים והסביבה',
      calcGeoCenter: 'מרכז',
      calcTimeLabel: 'שעות שידור',
      calcTimeAll: 'כל שעות היממה',
      calcTimeMorning: 'בוקר',
      calcTimeNoon: 'צהריים',
      calcTimeEvening: 'ערב',
      calcTimeNight: 'שעות הלילה',
      calcChannelLabel: 'תחנה / פודקאסט',
      calcChannelAll: 'כל התחנות והפודקאסטים',
      calcStationGalgalatz: 'גלגלצ',
      calcStationKan: 'כאן ג׳',
      calcStationRadius: 'רדיוס 100',
      calcStationPodcast: 'פודקאסט (סדרה נבחרת)',
      calcOccupancyLine: 'הערכה לפי אזור ושעות בלבד',
      calcBasePriceLine: 'מחיר בסיס חודשי (נייטרלי): ₪{price}',
      calcRangeHint: 'טווח מחיר חודשי: ₪{min}–₪{max} לאחר משקלים.',
      calcEstimatedLabel: 'הערכת מחיר לקמפיין',
      calcDisclaimer:
        'הערה: ההערכה מבוססת על תעריף קבוע של ₪20 לכל 1,000 הצגות וידאו (CPM) ובלבד. אינה משקפת תפוסה או תחרות. הערכה בלבד; המחיר הסופי נקבע בהצעה מסחרית.',
      calcLoading: 'טוען…',
      calcError: 'לא ניתן לטעון נתונים מהשרת; מוצגת הערכה על בסיס תקרת הטווח (₪15,000).',
      calcFactorGeo: 'מיקום',
      calcFactorTime: 'שעות',
      calcFactorChannel: 'תחנה/פודקאסט',
      ctaWhatsAppBase:
        'ברצוני לקבל פרטים על חבילת הפרסום המנצחת של GSRadioTV',
      ctaWhatsAppCpmLine: 'תעריף שקוף: ₪{cpm} לכל 1,000 הצגות וידאו (CPM).',
      ctaWhatsAppCalcIntro: 'בחירות מהמחשבון בדף הנחיתה:',
    },
  },
  en: {
    landing: {
      heroTitle1: 'The media where they finally see,',
      heroTitle2: 'remember and hear ',
      heroTitle2Bold: 'your money',
      heroTitle2Suffix: '!',
      heroDesc1: 'Through a unique partnership with ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ', your brand is present in over ',
      heroDesc1Highlight: '400,000 households',
      heroDesc1End: ' in Israel – while watching and listening to radio and podcast channels on TV.',
      heroDesc2: 'These are rare moments of attention:',
      heroDesc2Line2: 'music, content, calm – and the screen is on.',
      videoTitle: 'The home advertising revolution: when radio meets the TV screen',
      pricingCtaTitle: 'We’d love to hear from you',
      pricingCtaSubtitle: 'Simple, transparent CPM pricing.',
      pricingCtaCpmUnit: 'CPM',
      pricingCtaPerThousand: 'Per 1,000 video impressions',
      pricingTitle: 'CPM pricing',
      pricingSubtitle:
        '₪15 per 1,000 video impressions. Tap below to reach us on WhatsApp.',
      pricePerMonth: 'per month',
      pricingCardPriceLine: '₪15 CPM',
      pricingCardSubline: 'Per 1,000 video impressions',
      feature1: 'Ads on GSRadio Android TV and Partner TV',
      feature2: 'Flat CPM — ₪15 per thousand impressions',
      ctaStart: 'Start now',
      faqTitle: 'FAQ',
      faq1Q: 'What is GSRadio TV?',
      faq1A:
        'GSRadio TV is GSRadio\'s ad experience on smart TV (Android TV), together with Partner TV: calm background ads while listeners enjoy radio and podcasts on the big screen — in over 400,000 households in Israel.',
      faq2Q: 'How much does advertising cost?',
      faq2A:
        'Pricing is ₪15 per 1,000 video impressions (CPM). Tap “Start now” to message us on WhatsApp; final terms are confirmed in a commercial proposal.',
      faq3Q: 'How do I get started?',
      faq3A: 'Click "Start now" and contact us. We will help you prepare the video and design according to our guidelines.',
      faq4Q: 'What are the video requirements?',
      faq4A:
        'Video must be exactly 20 seconds, silent, MP4 (H.264). Full specs are provided when you onboard.',
      serviceHighlightsTitle: 'What we offer businesses',
      serviceHighlightsSubtitle:
        'Calm video ads while listeners tune in, on the GSRadio Android TV app (with Partner TV) — clear messaging without feed noise.',
      servicePoint1Title: 'Big screen, home attention',
      servicePoint1Text:
        'While listening to radio at home, the TV is the focus — calm background ads without chasing clicks.',
      servicePoint2Title: 'Volume-based pricing',
      servicePoint2Text:
        '₪15 per 1,000 impressions (CPM); campaign volume and timing are agreed with you.',
      servicePoint3Title: '20–30 second videos',
      servicePoint3Text:
        'Creative by location and/or station, with optional interactive elements and production services (paid).',
      statBroadcastHoursVal: '14,000+',
      statBroadcastHours: 'broadcast hours per month (approx.)',
      statViewingHoursVal: '600+',
      statViewingHours: 'viewing hours per day (approx.)',
      statHomesVal: '400,000',
      statHomes: 'households with set-top boxes (Israel)',
      serviceStatsFootnote: '* Illustrative figures; sources per strategy and market updates.',
      calcSectionTitle: 'Estimated price calculator',
      calcSectionSubtitle:
        'Enter your expected video impressions. Rate: ₪20 per 1,000 impressions (CPM).',
      calcImpressionsLabel: 'Expected video impressions',
      calcCpmRateHint: '₪20 per 1,000 impressions.',
      calcEstimatedPeriod: 'For selected volume',
      calcGeoLabel: 'Geography',
      calcGeoAll: 'Nationwide',
      calcGeoNorth: 'North',
      calcGeoSouth: 'South',
      calcGeoShfela: 'Shfela',
      calcGeoSharon: 'Sharon',
      calcGeoTelAviv: 'Tel Aviv area',
      calcGeoJerusalem: 'Jerusalem area',
      calcGeoCenter: 'Center',
      calcTimeLabel: 'Hours',
      calcTimeAll: 'All day',
      calcTimeMorning: 'Morning',
      calcTimeNoon: 'Afternoon',
      calcTimeEvening: 'Evening',
      calcTimeNight: 'Night hours',
      calcChannelLabel: 'Station / podcast',
      calcChannelAll: 'All stations and podcasts',
      calcStationGalgalatz: 'Galgalatz',
      calcStationKan: 'Kan G',
      calcStationRadius: 'Radius 100',
      calcStationPodcast: 'Podcast (selected series)',
      calcOccupancyLine: 'Estimate by area and hours only',
      calcBasePriceLine: 'Neutral monthly base: ₪{price}',
      calcRangeHint: 'Monthly range: ₪{min}–₪{max} after weights.',
      calcEstimatedLabel: 'Campaign estimate',
      calcDisclaimer:
        'Note: The estimate uses a fixed rate of ₪20 per 1,000 video impressions (CPM) only. It does not reflect inventory or competition. Estimate only; final pricing is set in a commercial proposal.',
      calcLoading: 'Loading…',
      calcError: 'Could not load server data; showing estimate using the configured maximum base (₪15,000).',
      calcFactorGeo: 'Geo',
      calcFactorTime: 'Hours',
      calcFactorChannel: 'Station/podcast',
      ctaWhatsAppBase:
        'I would like details about the GSRadioTV winning advertising package.',
      ctaWhatsAppCpmLine: 'Transparent rate: ₪{cpm} per 1,000 video impressions (CPM).',
      ctaWhatsAppCalcIntro: 'Selections from the landing page calculator:',
    },
  },
  ru: {
    landing: {
      heroTitle1: 'Медиа, где наконец видят,',
      heroTitle2: 'помнят и слышат ',
      heroTitle2Bold: 'ваши деньги',
      heroTitle2Suffix: '!',
      heroDesc1: 'Благодаря партнёрству с ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ' ваш бренд представлен в более чем ',
      heroDesc1Highlight: '400 000 домохозяйствах',
      heroDesc1End: ' в Израиле – во время просмотра и прослушивания радио и подкастов на ТВ.',
      heroDesc2: 'Это редкие моменты внимания:',
      heroDesc2Line2: 'музыка, контент, спокойствие – и экран включён.',
      videoTitle: 'Домашняя рекламная революция: когда радио встречает экран телевизора',
      pricingCtaTitle: 'Свяжитесь с нами',
      pricingCtaSubtitle: 'Прозрачное CPM-ценообразование.',
      pricingCtaCpmUnit: 'CPM',
      pricingCtaPerThousand: 'За 1 000 показов видео',
      pricingTitle: 'Ценообразование по CPM',
      pricingSubtitle:
        '₪15 за 1 000 показов видео. Напишите нам в WhatsApp — расскажем подробности.',
      pricePerMonth: 'в месяц',
      pricingCardPriceLine: '₪15 CPM',
      pricingCardSubline: 'За 1 000 показов видео',
      feature1: 'Реклама на GSRadio Android TV и Partner TV',
      feature2: 'Фиксированный CPM — ₪15 за тысячу показов',
      ctaStart: 'Начать',
      faqTitle: 'Частые вопросы',
      faq1Q: 'Что такое GSRadio TV?',
      faq1A:
        'GSRadio TV — рекламная платформа GSRadio на Smart TV (Android TV) совместно с Partner TV: спокойная фоновая реклама во время прослушивания радио и подкастов на экране — более чем в 400 000 домохозяйств в Израиле.',
      faq2Q: 'Сколько стоит реклама?',
      faq2A:
        'Тариф: ₪15 за 1 000 показов видео (CPM). Нажмите «Начать», чтобы написать в WhatsApp; итоговые условия — в коммерческом предложении.',
      faq3Q: 'Как начать?',
      faq3A: 'Нажмите «Начать» и свяжитесь с нами. Мы поможем подготовить видео и дизайн по нашим рекомендациям.',
      faq4Q: 'Какие требования к видео?',
      faq4A:
        'Ровно 20 секунд, без звука, MP4 (H.264). Полные требования — при подключении.',
      serviceHighlightsTitle: 'Что мы предлагаем бизнесу',
      serviceHighlightsSubtitle:
        'Спокойная видеореклама во время прослушивания в приложении GSRadio на Android TV (с Partner TV).',
      servicePoint1Title: 'Большой экран, внимание дома',
      servicePoint1Text:
        'Пока слушают радио дома, телевизор в центре — спокойный фон без гонки за кликами.',
      servicePoint2Title: 'Тариф по объёму показов',
      servicePoint2Text:
        '₪15 за 1 000 показов (CPM); объём и сроки кампании согласуем с вами.',
      servicePoint3Title: 'Ролики 20–30 секунд',
      servicePoint3Text:
        'Контент по гео и/или станции, с интерактивом и продакшеном (отдельно).',
      statBroadcastHoursVal: '14,000+',
      statBroadcastHours: 'часов эфира в месяц (примерно)',
      statViewingHoursVal: '600+',
      statViewingHours: 'часов просмотра в день (примерно)',
      statHomesVal: '400,000',
      statHomes: 'домохозяйств с приставками (Израиль)',
      serviceStatsFootnote: '* Ориентировочные данные.',
      calcSectionTitle: 'Калькулятор ориентировочной цены',
      calcSectionSubtitle:
        'Введите ожидаемое число показов видео. Ставка: ₪20 за 1 000 показов (CPM).',
      calcImpressionsLabel: 'Ожидаемые показы видео',
      calcCpmRateHint: '₪20 за 1 000 показов.',
      calcEstimatedPeriod: 'Для выбранного объёма',
      calcGeoLabel: 'География',
      calcGeoAll: 'Вся страна',
      calcGeoNorth: 'Север',
      calcGeoSouth: 'Юг',
      calcGeoShfela: 'Шфела',
      calcGeoSharon: 'Шарон',
      calcGeoTelAviv: 'Тель-Авив и область',
      calcGeoJerusalem: 'Иерусалим и область',
      calcGeoCenter: 'Центр',
      calcTimeLabel: 'Часы',
      calcTimeAll: 'Весь день',
      calcTimeMorning: 'Утро',
      calcTimeNoon: 'День',
      calcTimeEvening: 'Вечер',
      calcTimeNight: 'Ночные часы',
      calcChannelLabel: 'Станция / подкаст',
      calcChannelAll: 'Все станции и подкасты',
      calcStationGalgalatz: 'Galgalatz',
      calcStationKan: 'Kan G',
      calcStationRadius: 'Radius 100',
      calcStationPodcast: 'Подкаст (серия)',
      calcOccupancyLine: 'Оценка только по региону и времени',
      calcBasePriceLine: 'Нейтральная база в месяц: ₪{price}',
      calcRangeHint: 'Диапазон: ₪{min}–₪{max} после весов.',
      calcEstimatedLabel: 'Оценка кампании',
      calcDisclaimer:
        'Примечание: оценка использует только фиксированную ставку ₪20 за 1 000 показов видео (CPM). Не учитывает занятость слотов или конкуренцию. Только оценка; итоговая цена — в коммерческом предложении.',
      calcLoading: 'Загрузка…',
      calcError: 'Нет данных с сервера; показана оценка по верхней границе диапазона (₪15,000).',
      calcFactorGeo: 'Гео',
      calcFactorTime: 'Часы',
      calcFactorChannel: 'Станция',
      ctaWhatsAppBase:
        'Хочу получить информацию о выигрышном рекламном пакете GSRadioTV.',
      ctaWhatsAppCpmLine: 'Прозрачный тариф: ₪{cpm} за 1 000 показов видео (CPM).',
      ctaWhatsAppCalcIntro: 'Выбор в калькуляторе на лендинге:',
    },
  },
  ar: {
    landing: {
      heroTitle1: 'الوسيط الذي يرون فيه أخيراً،',
      heroTitle2: 'يتذكرون ويسمعون ',
      heroTitle2Bold: 'أموالك',
      heroTitle2Suffix: '!',
      heroDesc1: 'من خلال شراكة فريدة مع ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: '، علامتك التجارية حاضرة في أكثر من ',
      heroDesc1Highlight: '٤٠٠٬٠٠٠ أسرة',
      heroDesc1End: ' في إسرائيل – أثناء المشاهدة والاستماع لمحطات الراديو والبودكاست على التلفزيون.',
      heroDesc2: 'لحظات نادرة من الاهتمام:',
      heroDesc2Line2: 'موسيقى، محتوى، هدوء – والشاشة مفتوحة.',
      videoTitle: 'ثورة الإعلان المنزلي: عندما يلتقي الراديو بشاشة التلفزيون',
      pricingCtaTitle: 'يسعدنا تواصلكم',
      pricingCtaSubtitle: 'تسعير CPM بسيط وشفاف.',
      pricingCtaCpmUnit: 'CPM',
      pricingCtaPerThousand: 'لكل ‏١٬٠٠٠‏ عرض فيديو',
      pricingTitle: 'تسعير حسب CPM',
      pricingSubtitle:
        '‏₪15‏ لكل ‏١٬٠٠٠‏ عرض فيديو. تواصلوا معنا عبر واتساب للتفاصيل.',
      pricePerMonth: 'شهرياً',
      pricingCardPriceLine: '‏₪15‏ CPM',
      pricingCardSubline: 'لكل ‏١٬٠٠٠‏ عرض فيديو',
      feature1: 'إعلان على GSRadio Android TV و Partner TV',
      feature2: 'CPM ثابت — ‏₪15‏ لكل ألف عرض',
      ctaStart: 'ابدأ الآن',
      faqTitle: 'الأسئلة الشائعة',
      faq1Q: 'ما هو GSRadio TV؟',
      faq1A:
        'GSRadio TV هي منصة الإعلانات من GSRadio على التلفزيون الذكي (Android TV) مع Partner TV: إعلانات خلفية هادئة أثناء الاستماع للراديو والبودكاست على الشاشة — في أكثر من ٤٠٠٬٠٠٠ أسرة في إسرائيل.',
      faq2Q: 'كم تكلفة الإعلان؟',
      faq2A:
        'التسعير ‏₪15‏ لكل ‏١٬٠٠٠‏ عرض فيديو (CPM). اضغط «ابدأ الآن» للتواصل عبر واتساب؛ الشروط النهائية في عرض تجاري.',
      faq3Q: 'كيف أبدأ؟',
      faq3A: 'اضغط "ابدأ الآن" وتواصل معنا. سنساعدك في إعداد الفيديو والتصميم حسب إرشاداتنا.',
      faq4Q: 'ما متطلبات الفيديو؟',
      faq4A:
        '٢٠ ثانية بالضبط، بدون صوت، MP4 (H.264). التفاصيل الكاملة تُقدَّم عند الانضمام.',
      serviceHighlightsTitle: 'ما نقدمه للأعمال',
      serviceHighlightsSubtitle:
        'إعلان فيديو هادئ أثناء الاستماع عبر تطبيق GSRadio على Android TV (مع Partner TV).',
      servicePoint1Title: 'شاشة كبيرة، انتباه منزلي',
      servicePoint1Text:
        'أثناء الاستماع للراديو في المنزل، التلفزيون هو المحور — خلفية هادئة دون مطاردة النقرات.',
      servicePoint2Title: 'تسعير بحجم مرات العرض',
      servicePoint2Text:
        '‏₪15‏ لكل ‏١٬٠٠٠‏ عرض (CPM); حجم الحملة والجدولة يُحدَّدان معكم.',
      servicePoint3Title: 'فيديو 20–30 ثانية',
      servicePoint3Text:
        'محتوى حسب الموقع و/أو المحطة، مع عناصر تفاعلية وإنتاج (برسوم).',
      statBroadcastHoursVal: '14,000+',
      statBroadcastHours: 'ساعات بث شهرياً (تقريباً)',
      statViewingHoursVal: '600+',
      statViewingHours: 'ساعات مشاهدة يومياً (تقريباً)',
      statHomesVal: '400,000',
      statHomes: 'أسرة مع أجهزة استقبال (إسرائيل)',
      serviceStatsFootnote: '* أرقام توضيحية.',
      calcSectionTitle: 'حاسبة سعر تقديرية',
      calcSectionSubtitle:
        'أدخل تقديراً لعدد مرات عرض الفيديو. السعر: ‏₪20‏ لكل ‏١٬٠٠٠‏ عرض (CPM).',
      calcImpressionsLabel: 'مرات عرض الفيديو المتوقعة',
      calcCpmRateHint: '‏₪20‏ لكل ‏١٬٠٠٠‏ عرض.',
      calcEstimatedPeriod: 'لحجم الإدخال',
      calcGeoLabel: 'المنطقة',
      calcGeoAll: 'كل البلاد',
      calcGeoNorth: 'الشمال',
      calcGeoSouth: 'الجنوب',
      calcGeoShfela: 'الشفيلة',
      calcGeoSharon: 'الشارون',
      calcGeoTelAviv: 'تل أبيب والمنطقة',
      calcGeoJerusalem: 'القدس والمنطقة',
      calcGeoCenter: 'الوسط',
      calcTimeLabel: 'الساعات',
      calcTimeAll: 'طوال اليوم',
      calcTimeMorning: 'صباحاً',
      calcTimeNoon: 'ظهراً',
      calcTimeEvening: 'مساءً',
      calcTimeNight: 'ساعات الليل',
      calcChannelLabel: 'محطة / بودكاست',
      calcChannelAll: 'كل المحطات والبودكاست',
      calcStationGalgalatz: 'جلجلتس',
      calcStationKan: 'كان ج',
      calcStationRadius: 'Radius 100',
      calcStationPodcast: 'بودكاست (سلسلة)',
      calcOccupancyLine: 'تقدير حسب المنطقة والساعات فقط',
      calcBasePriceLine: 'أساس شهري محايد: ₪{price}',
      calcRangeHint: 'النطاق: ₪{min}–₪{max} بعد الأوزان.',
      calcEstimatedLabel: 'تقدير الحملة',
      calcDisclaimer:
        'ملاحظة: التقدير يعتمد فقط على سعر ثابت ‏₪20‏ لكل ‏١٬٠٠٠‏ عرض فيديو (CPM). لا يعكس توفر المخزون أو المنافسة. تقدير فقط؛ السعر النهائي في عرض تجاري.',
      calcLoading: 'جاري التحميل…',
      calcError: 'تعذر تحميل بيانات الخادم؛ يُعرض تقدير بسقف النطاق (₪15,000).',
      calcFactorGeo: 'منطقة',
      calcFactorTime: 'ساعات',
      calcFactorChannel: 'محطة',
      ctaWhatsAppBase:
        'أرغب بالحصول على تفاصيل حول باقة الإعلانات الرابحة لـ GSRadioTV.',
      ctaWhatsAppCpmLine: 'سعر شفاف: ‏₪{cpm}‏ لكل ‏١٬٠٠٠‏ عرض فيديو (CPM).',
      ctaWhatsAppCalcIntro: 'الخيارات من الحاسبة في صفحة الهبوط:',
    },
  },
  am: {
    landing: {
      heroTitle1: 'ሚዲያ በመጨረሻ የሚያዩት፣',
      heroTitle2: 'የሚያስታውሱና የሚሰሙት ',
      heroTitle2Bold: 'ገንዘብህ',
      heroTitle2Suffix: '!',
      heroDesc1: 'ከ',
      heroDesc1Partner: 'Partner TV',
      heroDesc1Rest: ' ጋር ባለው ልዩ ትብብር በእስራኤል በ',
      heroDesc1Highlight: '400,000 ቤተሰቦች',
      heroDesc1End: ' ብዙ የብራንድ መገኘት – በቴሌቪዥን ራዲዮና ፖድካስት በሚመለከቱበት ጊዜ።',
      heroDesc2: 'እነዚህ ከልብ ትኩረት ያላነሱ ጊዜዎች ናቸው፡',
      heroDesc2Line2: 'ሙዚቃ፣ ይዘት፣ ርስት – እና ስክሪኑ ተከፍቷል።',
      videoTitle: 'የቤት ውስጥ የማስታወቂያ አብዮት፡ ራዲዮ ከቴሌቪዥን ስክሪን ጋር በሚገናኝበት ጊዜ',
      pricingCtaTitle: 'ከእኛ ጋር ይገናኙ',
      pricingCtaSubtitle: 'ቀላል እና ግልጽ የሆነ CPM ዋጋ።',
      pricingCtaCpmUnit: 'CPM',
      pricingCtaPerThousand: 'ለቪዲዮ 1,000 ማሳያዎች',
      pricingTitle: 'የቪዲዮ ማሳያ CPM ዋጋ',
      pricingSubtitle:
        'ለቪዲዮ 1,000 ማሳያዎች ₪15። ዝርዝሮች በዋትስአፕ እንድንገናኝ ይጫኑ።',
      pricePerMonth: 'በወር',
      pricingCardPriceLine: '₪15 CPM',
      pricingCardSubline: 'ለቪዲዮ 1,000 ማሳያዎች',
      feature1: 'በ GSRadio Android TV እና Partner TV ማስታወቂያ',
      feature2: 'የተረጋጋ CPM — በአንድ ሺህ ማሳያ ₪15',
      ctaStart: 'አሁን ጀምር',
      faqTitle: 'ተደጋግሞ የሚጠየቁ ጥያቄዎች',
      faq1Q: 'GSRadio TV ምንድነው?',
      faq1A:
        'GSRadio TV የ GSRadio የማስታወቂያ ተሞክሮ በስማርት ቴሌቪዥን (Android TV) ከ Partner TV ጋር ነው፡ በ400,000+ ቤተሰቦች ራዲዮና ፖድካስት በትልቁ ስክሪን ሲያዳምጡ የተረጋጋ ዳራ ማስታወቂያ።',
      faq2Q: 'ማስታወቂያ ዋጋ ስንት ነው?',
      faq2A:
        'ዋጋው በቪዲዮ 1,000 ማሳያዎች ₪15 (CPM) ነው። «አሁን ጀምር» በዋትስአፕ ይጻፉን፤ የመጨሻ ውል በንግድ ምስርያት።',
      faq3Q: 'እንዴት እጀምራለሁ?',
      faq3A: '"አሁን ጀምር" ጠቅ አድርገህ ያግኙን። በእኛ መመሪያዎች ቪዲዮንና ዲዛይን እንረዳለን።',
      faq4Q: 'ለቪዲዮ መስፈርቶች ምንድነው?',
      faq4A:
        '20 ሰከንድ በትክክል፣ ድምጽ የለውም፣ MP4 (H.264)። ሙሉ ዝርዝሮች በመቀላቀል ይሰጣሉ።',
      serviceHighlightsTitle: 'ለንግዶች የምንሰጠው',
      serviceHighlightsSubtitle:
        'በ GSRadio Android TV መተግበሪያ (ከ Partner TV ጋር) በሚያዳምጡ ጊዜ የተረጋጋ ቪዲዮ ማስታወቂያ።',
      servicePoint1Title: 'ትልቅ ስክሪን፣ የቤት ትኩረት',
      servicePoint1Text:
        'በቤት ራዲዮ ሲያዳምጡ ቴሌቪዥን ማዕከል ነው — የተረጋጋ ዳራ።',
      servicePoint2Title: 'በማሳያ መጠን ዋጋ',
      servicePoint2Text:
        'በቪዲዮ 1,000 ማሳያዎች ₪15 (CPM)፤ የዘመቻው መጠን እና ጊዜ ከእናንተ ጋር ይስማማል።',
      servicePoint3Title: '20–30 ሰከንድ ቪዲዮ',
      servicePoint3Text:
        'በአካባቢ እና/ወይም ስቴሽን፣ ኢንተርአክቲቭ እና ምርት (በክፍያ)።',
      statBroadcastHoursVal: '14,000+',
      statBroadcastHours: 'የማስተላለፍ ሰዓቶች በወር (ግምት)',
      statViewingHoursVal: '600+',
      statViewingHours: 'የመመልከት ሰዓቶች በቀን (ግምት)',
      statHomesVal: '400,000',
      statHomes: 'የቤተሰብ ቁጥሮች ከሴት-ቶፕ (እስራኤል)',
      serviceStatsFootnote: '* ለምሳሌ ቁጥሮች።',
      calcSectionTitle: 'የዋጋ ግምት ካልኩሌተር',
      calcSectionSubtitle:
        'የሚጠበቁ የቪዲዮ ማሳያ ቁጥሮች አስገባ። ተመን፡ በቪዲዮ 1,000 ማሳያዎች ₪20 (CPM)።',
      calcImpressionsLabel: 'የሚጠበቁ የቪዲዮ ማሳያዎች',
      calcCpmRateHint: 'ለቪዲዮ 1,000 ማሳያዎች ₪20።',
      calcEstimatedPeriod: 'ለወደፊት የተያዘው መጠን',
      calcGeoLabel: 'አካባቢ',
      calcGeoAll: 'ሙሉ ሀገር',
      calcGeoNorth: 'ሰሜን',
      calcGeoSouth: 'ደቡብ',
      calcGeoShfela: 'ሽፍላ',
      calcGeoSharon: 'ሻሮን',
      calcGeoTelAviv: 'ተል አቪቭ አካባቢ',
      calcGeoJerusalem: 'ኢየሩሳሌም አካባቢ',
      calcGeoCenter: 'መሃል',
      calcTimeLabel: 'ሰዓታት',
      calcTimeAll: 'ሙሉ ቀን',
      calcTimeMorning: 'ጧት',
      calcTimeNoon: 'ከሰዓት',
      calcTimeEvening: 'ምሽት',
      calcTimeNight: 'የሌሊት ሰዓታት',
      calcChannelLabel: 'ስቴሽን / ፖድካስት',
      calcChannelAll: 'ሁሉም ስቴሽኖች እና ፖድካስቶች',
      calcStationGalgalatz: 'Galgalatz',
      calcStationKan: 'Kan G',
      calcStationRadius: 'Radius 100',
      calcStationPodcast: 'ፖድካስት (ተከታታይ)',
      calcOccupancyLine: 'ግምት በአካባቢ እና ሰዓት ብቻ',
      calcBasePriceLine: 'አማካይ መሠረታዊ ዋጋ በወር: ₪{price}',
      calcRangeHint: 'ክልል: ₪{min}–₪{max} ከክብደቶች በኋላ።',
      calcEstimatedLabel: 'የዘመቻ ግምት',
      calcDisclaimer:
        'ማስታወቂያ፡ ግምቱ በቪዲዮ 1,000 ማሳያዎች ₪20 የተረጋጋ ተመን (CPM) ብቻ ነው። ክምችት ወይም ተፎካካሪ አያንጸባርቅም። ግምት ብቻ፤ የመጨሻ ዋጋ በንግድ ምስርያት።',
      calcLoading: 'በመጫን ላይ…',
      calcError: 'ከአገልጋይ ውሂብ አልተጫነም፤ በተቀናጀ ከፍተኛ መሠረት (₪15,000) ግምት ይታያል።',
      calcFactorGeo: 'አካባቢ',
      calcFactorTime: 'ሰዓት',
      calcFactorChannel: 'ስቴሽን',
      ctaWhatsAppBase:
        'ስለ GSRadioTV ድልድይ የማስታወቂያ ጥቅል ዝርዝሮች እፈልጋለሁ።',
      ctaWhatsAppCpmLine: 'ግልጽ ተመን፡ በቪዲዮ 1,000 ማሳያዎች ₪{cpm} (CPM)።',
      ctaWhatsAppCalcIntro: 'ከመሬት ገጹ ካልኩሌተር ምርጫዎች፡',
    },
  },
};

export function getTranslation(lang, section, key) {
  const sectionData = translations[lang]?.[section];
  return sectionData?.[key] ?? translations.he?.[section]?.[key] ?? key;
}
